import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../adapters/xhr/httpClient";
import { ApiURLs, API_BASE_URL } from "../../common/url";
import { AppLocalStorage, AppLocalStorageItems } from "../../helpers/localStorageHelper";
import { AppRoutes } from "../../routingInfo/routes";
import { validateAuthCode } from "../../services/msalAuthService";
import { setUserAuth } from "../../store/auth/authSlice";
import { PageLoader } from "../loader/pageLoader";
import { handleLoginResponse } from "./loginResponseHandler";


export function Auth(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
        const code = searchParams.get('code');
        if (code) {
            searchParams.delete("code");
            let updatedSearchParams = new URLSearchParams('');
            let isUserDocumentsExists = false
            setSearchParams(updatedSearchParams.toString());
            validateAuthCode(API_BASE_URL + ApiURLs.Auth.VerifyMSALIdentity, { code: code })
                .then((res) => {
                    handleLoginResponse(res, navigate, dispatch)
                })
        }
        else
            navigate(AppRoutes.signIn, { replace: true, })
    }, []);

    return <React.Fragment>
        {/* <h1>Authenticating...</h1>
        <h2>Please wait.</h2> */}
        <PageLoader />
    </React.Fragment>
}